import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import HvSvg from 'src/components/HvSvg';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uiDux from 'src/redux/ui';
import appDux from 'src/redux/app';
import splitDux from 'src/redux/split';
import { selectors as macheteReduxSelectors } from 'src/machete-redux';
import 'pepjs';

import {
  ToolButtonsContainer,
  ToolButtonLabel,
  SplitToolButton,
  SelectToolButton,
} from './styled';

const mapStateToProps = (state) => ({
  isSelectToolActive: appDux.selectors.isSelectToolActive(state),
  isSplitToolDisabled: !splitDux.selectors.isSplitToolButtonEnabled(state),
  isDesignModeActive: appDux.selectors.isDesignModeActive(state),
  selectedNodeIds: macheteReduxSelectors.segmentation.getSelectedNodeIds(state),
  isSelectToolDisabled: splitDux.selectors.isSplitToolActive(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleSplitToolClick: splitDux.actions.handleSplitToolClick,
      handleSelectToolButtonClick: uiDux.actions.handleSelectToolButtonClick,
    },
    dispatch,
  );

export class ToolButtons extends PureComponent {
  static propTypes = {
    handleSelectToolButtonClick: PropTypes.func.isRequired,
    handleSplitToolClick: PropTypes.func.isRequired,
    isDesignModeActive: PropTypes.bool.isRequired,
    isSelectToolActive: PropTypes.bool.isRequired,
    isSelectToolDisabled: PropTypes.bool.isRequired,
    isSplitToolDisabled: PropTypes.bool.isRequired,
    selectedNodeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  render() {
    const {
      handleSelectToolButtonClick,
      handleSplitToolClick,
      isSelectToolActive,
      isSplitToolDisabled,
      isDesignModeActive,
      isSelectToolDisabled,
      selectedNodeIds,
    } = this.props;

    return (
      <ToolButtonsContainer>
        <div touch-action="none">
          {/* Prevent zoom on touch devices. Also note, touch-action is incompatible with styled and React components (see NS-947) */}
          <SplitToolButton
            onClick={() =>
              handleSplitToolClick({
                nodes: selectedNodeIds,
                isEditing: false,
              })
            }
            isVisible={isDesignModeActive}
            disabled={isSplitToolDisabled}
            data-selenium="splitToolButton"
          >
            <HvSvg src={require('src/assets/images/ic-split-tool.svg')} />
            <ToolButtonLabel>Split Tool</ToolButtonLabel>
          </SplitToolButton>

          <SelectToolButton
            onClick={handleSelectToolButtonClick}
            isActive={isSelectToolActive}
            isVisible={isDesignModeActive}
            disabled={isSelectToolDisabled}
            data-selenium="selectToolButton"
          >
            <HvSvg src={require('src/assets/images/ic-select-tool.svg')} />
            <ToolButtonLabel>Select Tool</ToolButtonLabel>
          </SelectToolButton>
        </div>
      </ToolButtonsContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolButtons);
